import { createApi } from '@reduxjs/toolkit/query/react';
import EnhancedBaseQuery from '../../Api/createApiConfig';

const bulkUploadApi = createApi({
    reducerPath: 'bulkUploadApi',
    baseQuery: EnhancedBaseQuery,
    endpoints: () => ({}),
});

const injectedBulkUploadApi = bulkUploadApi.injectEndpoints({
    endpoints: (builder) => ({
        validateImages: builder.mutation({
            query: (config) => ({
                url: '/eyetests/validateImages',
                method: 'POST',
                body: config,
            }),
        }),
        uplooadImages: builder.mutation({
            query: (config) => ({
                url: '/eyetests/image/upload1?CountId=0',
                method: 'POST',
                body: config,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useValidateImagesMutation, useUplooadImagesMutation } =
    injectedBulkUploadApi;
export default bulkUploadApi;
